import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ACRStore from "./ACRStore";
/**
 * Check if a patient has any submissions with unsaved changes
 * Returns the first submission ID with changes, or null if none found
 */
export var findSubmissionWithUnsavedChanges = function findSubmissionWithUnsavedChanges(patientId) {
  var storeState = ACRStore.getRawState();
  var changedFieldsForPatient = storeState.submissionChangedFields[patientId];
  if (changedFieldsForPatient) {
    for (var _i = 0, _Object$entries = Object.entries(changedFieldsForPatient); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        submissionId = _Object$entries$_i[0],
        changedFields = _Object$entries$_i[1];
      if (changedFields && changedFields.size > 0) {
        return Number(submissionId);
      }
    }
  }
  return null;
};

// Remove a submission from the minimized list for a given patient
export var removeFromMinimized = function removeFromMinimized(patientId, submissionId) {
  ACRStore.update(function (store) {
    var minimizedList = store.minimizedSubmissions[patientId] || [];
    store.minimizedSubmissions[patientId] = minimizedList.filter(function (m) {
      return m.submissionId !== submissionId;
    });
  });
};

// Clear all minimized submissions for a patient
export var clearMinimizedForPatient = function clearMinimizedForPatient(patientId) {
  ACRStore.update(function (store) {
    delete store.minimizedSubmissions[patientId];
  });
};

// Clear field errors and submit errors for a submission
export var clearSubmissionErrors = function clearSubmissionErrors(submissionId) {
  ACRStore.update(function (store) {
    delete store.fieldErrors[submissionId];
    delete store.submitErrors[submissionId];
    delete store.originalErrorFields[submissionId];
  });
};

// Clear changed fields for a submission
export var clearChangedFields = function clearChangedFields(patientId, submissionId) {
  ACRStore.update(function (store) {
    var _store$submissionChan;
    if ((_store$submissionChan = store.submissionChangedFields[patientId]) !== null && _store$submissionChan !== void 0 && _store$submissionChan[submissionId]) {
      store.submissionChangedFields[patientId][submissionId] = new Set();
    }
  });
};

// Clear all submission data for a patient (form data, ready status, changed fields, original data)
export var clearSubmissionDataForPatient = function clearSubmissionDataForPatient(patientId) {
  ACRStore.update(function (store) {
    delete store.submissionFormData[patientId];
    delete store.submissionReadyStatus[patientId];
    delete store.submissionChangedFields[patientId];
    delete store.submissionOriginalFieldData[patientId];
  });
};

// Discard changes and clear errors for a submission
export var discardSubmissionChanges = function discardSubmissionChanges(patientId, submissionId) {
  ACRStore.update(function (store) {
    var _store$submissionChan2;
    // Clear changed fields
    if ((_store$submissionChan2 = store.submissionChangedFields[patientId]) !== null && _store$submissionChan2 !== void 0 && _store$submissionChan2[submissionId]) {
      store.submissionChangedFields[patientId][submissionId] = new Set();
    }

    // Clear errors
    delete store.fieldErrors[submissionId];
    delete store.submitErrors[submissionId];
    delete store.originalErrorFields[submissionId];
  });
};

// Clears changed fields, errors, and minimized submissions
export var discardAndCleanup = function discardAndCleanup(patientId, submissionId) {
  ACRStore.update(function (store) {
    var _store$submissionChan3;
    // Clear changed fields for this submission
    if ((_store$submissionChan3 = store.submissionChangedFields[patientId]) !== null && _store$submissionChan3 !== void 0 && _store$submissionChan3[submissionId]) {
      store.submissionChangedFields[patientId][submissionId] = new Set();
    }

    // Clear errors
    delete store.fieldErrors[submissionId];
    delete store.submitErrors[submissionId];
    delete store.originalErrorFields[submissionId];

    // Remove all minimized submissions for this patient
    delete store.minimizedSubmissions[patientId];
  });
};

// Remove a submission completely from the store
export var removeSubmissionCompletely = function removeSubmissionCompletely(patientId, submissionId) {
  ACRStore.update(function (store) {
    var _store$submissionChan4, _store$submissionForm, _store$submissionOrig, _store$submissionRead;
    // Remove from minimized list
    var minimizedList = store.minimizedSubmissions[patientId] || [];
    store.minimizedSubmissions[patientId] = minimizedList.filter(function (m) {
      return m.submissionId !== submissionId;
    });

    // Clear changed fields
    if ((_store$submissionChan4 = store.submissionChangedFields[patientId]) !== null && _store$submissionChan4 !== void 0 && _store$submissionChan4[submissionId]) {
      store.submissionChangedFields[patientId][submissionId] = new Set();
    }

    // Clear form data
    if ((_store$submissionForm = store.submissionFormData[patientId]) !== null && _store$submissionForm !== void 0 && _store$submissionForm[submissionId]) {
      delete store.submissionFormData[patientId][submissionId];
    }

    // Clear original field data
    if ((_store$submissionOrig = store.submissionOriginalFieldData[patientId]) !== null && _store$submissionOrig !== void 0 && _store$submissionOrig[submissionId]) {
      delete store.submissionOriginalFieldData[patientId][submissionId];
    }

    // Clear ready status
    if (((_store$submissionRead = store.submissionReadyStatus[patientId]) === null || _store$submissionRead === void 0 ? void 0 : _store$submissionRead[submissionId]) !== undefined) {
      delete store.submissionReadyStatus[patientId][submissionId];
    }

    // Clear errors
    delete store.fieldErrors[submissionId];
    delete store.submitErrors[submissionId];
    delete store.originalErrorFields[submissionId];
  });
};

// Update store after successful save or submit operation
export var updateStoreAfterSaveOrSubmit = function updateStoreAfterSaveOrSubmit(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$clearErrorsO = options.clearErrorsOnlyIfNoValidation,
    clearErrorsOnlyIfNoValidation = _options$clearErrorsO === void 0 ? false : _options$clearErrorsO;
  ACRStore.update(function (s) {
    // Store submission detail keyed by ID
    if (data !== null && data !== void 0 && data.id) {
      s.submissionDetails[data.id] = data;
    }
    if (data !== null && data !== void 0 && data.id) {
      // Get patient_id from store if not provided
      var patientId = (data === null || data === void 0 ? void 0 : data.patient_id) || Object.keys(s.submissionFormData || {}).find(function (pid) {
        var _s$submissionFormData;
        return (_s$submissionFormData = s.submissionFormData[pid]) === null || _s$submissionFormData === void 0 ? void 0 : _s$submissionFormData[data.id];
      });
      if (patientId) {
        var _s$submissionFormData2, _s$submissionOriginal;
        if (!((_s$submissionFormData2 = s.submissionFormData) !== null && _s$submissionFormData2 !== void 0 && _s$submissionFormData2[patientId])) {
          s.submissionFormData[patientId] = {};
        }
        if (!((_s$submissionOriginal = s.submissionOriginalFieldData) !== null && _s$submissionOriginal !== void 0 && _s$submissionOriginal[patientId])) {
          s.submissionOriginalFieldData[patientId] = {};
        }

        // Success path: update both formData and originalFieldData
        var newFormData = _objectSpread({}, (data === null || data === void 0 ? void 0 : data.field_data) || {});
        s.submissionFormData[patientId][data.id] = newFormData;
        s.submissionOriginalFieldData[patientId][data.id] = _objectSpread({}, newFormData);
      }
    }

    // Clear originalErrorFields based on operation type
    if (data !== null && data !== void 0 && data.id) {
      if (clearErrorsOnlyIfNoValidation) {
        var _data$validation_erro;
        // For save: only clear if no validation errors
        if (!(data !== null && data !== void 0 && (_data$validation_erro = data.validation_errors) !== null && _data$validation_erro !== void 0 && _data$validation_erro.length)) {
          delete s.originalErrorFields[data.id];
        }
      } else {
        // For submit: always clear
        delete s.originalErrorFields[data.id];
      }
    }
  });
};

// Handle partial validation errors - updates both ACRStore and React Query cache
export var handlePartialValidationError = function handlePartialValidationError(error, submissionId, queryClient, acrQueryKeys) {
  var _error$response, _error$response2;
  var fieldErrors = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.field_errors) || [];
  var submissionDetails = error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 ? void 0 : _error$response2.submission_details;
  if (!submissionDetails) {
    console.error("submission_details not found in error response");
    return {
      fieldErrors: fieldErrors
    };
  }

  // initializeOrUpdateSubmissionDetail preserves uncommitted user changes
  initializeOrUpdateSubmissionDetail(submissionDetails, {
    updateOriginalData: true
  });

  // Clear changed fields set since the save attempt completed
  if (submissionDetails !== null && submissionDetails !== void 0 && submissionDetails.patient_id) {
    ACRStore.update(function (store) {
      var _store$submissionChan5;
      if ((_store$submissionChan5 = store.submissionChangedFields) !== null && _store$submissionChan5 !== void 0 && (_store$submissionChan5 = _store$submissionChan5[submissionDetails.patient_id]) !== null && _store$submissionChan5 !== void 0 && _store$submissionChan5[submissionId]) {
        store.submissionChangedFields[submissionDetails.patient_id][submissionId] = new Set();
      }
    });
  }

  // Update React Query cache with backend's current state
  if (queryClient && acrQueryKeys) {
    queryClient.setQueryData([acrQueryKeys.SUBMISSION_DETAIL, submissionId], submissionDetails);
  }
  return {
    fieldErrors: fieldErrors
  };
};

// Initialize or update submission detail in store
export var initializeOrUpdateSubmissionDetail = function initializeOrUpdateSubmissionDetail(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$updateOrigin = options.updateOriginalData,
    updateOriginalData = _options$updateOrigin === void 0 ? false : _options$updateOrigin;
  ACRStore.update(function (s) {
    // Store submission detail keyed by ID
    if (data !== null && data !== void 0 && data.id) {
      s.submissionDetails[data.id] = data;
    }

    // Initialize/Update form data with field_data from API response
    if (data !== null && data !== void 0 && data.patient_id && data !== null && data !== void 0 && data.id) {
      var _s$submissionFormData3, _s$submissionChangedF, _s$submissionFormData4, _s$submissionChangedF2;
      if (!((_s$submissionFormData3 = s.submissionFormData) !== null && _s$submissionFormData3 !== void 0 && _s$submissionFormData3[data.patient_id])) {
        s.submissionFormData[data.patient_id] = {};
      }
      if (!((_s$submissionChangedF = s.submissionChangedFields) !== null && _s$submissionChangedF !== void 0 && _s$submissionChangedF[data.patient_id])) {
        s.submissionChangedFields[data.patient_id] = {};
      }
      var existingFormData = (_s$submissionFormData4 = s.submissionFormData) === null || _s$submissionFormData4 === void 0 || (_s$submissionFormData4 = _s$submissionFormData4[data.patient_id]) === null || _s$submissionFormData4 === void 0 ? void 0 : _s$submissionFormData4[data.id];
      var existingChangedFields = (_s$submissionChangedF2 = s.submissionChangedFields) === null || _s$submissionChangedF2 === void 0 || (_s$submissionChangedF2 = _s$submissionChangedF2[data.patient_id]) === null || _s$submissionChangedF2 === void 0 ? void 0 : _s$submissionChangedF2[data.id];
      if (!existingFormData) {
        // First time opening - initialize fresh
        s.submissionFormData[data.patient_id][data.id] = _objectSpread({}, (data === null || data === void 0 ? void 0 : data.field_data) || {});
        s.submissionChangedFields[data.patient_id][data.id] = new Set();
      } else {
        // Reopening - merge API data with existing, but preserve changed fields
        var _changedFieldsSet = existingChangedFields || new Set();
        var updatedFormData = _objectSpread({}, (data === null || data === void 0 ? void 0 : data.field_data) || {});

        // Preserve user changes that haven't been saved yet
        _changedFieldsSet.forEach(function (fieldName) {
          if (existingFormData[fieldName] !== undefined) {
            updatedFormData[fieldName] = existingFormData[fieldName];
          }
        });
        s.submissionFormData[data.patient_id][data.id] = updatedFormData;
      }

      // Update originalFieldData based on conditions
      var changedFieldsSet = existingChangedFields || new Set();
      var shouldUpdateOriginalData = updateOriginalData || !existingFormData || changedFieldsSet.size === 0;
      if (shouldUpdateOriginalData) {
        var _s$submissionOriginal2;
        if (!((_s$submissionOriginal2 = s.submissionOriginalFieldData) !== null && _s$submissionOriginal2 !== void 0 && _s$submissionOriginal2[data.patient_id])) {
          s.submissionOriginalFieldData[data.patient_id] = {};
        }
        if (updateOriginalData) {
          // Merge with existing (for populate/error scenarios)
          var existingOriginalData = s.submissionOriginalFieldData[data.patient_id][data.id] || {};
          var newFieldData = (data === null || data === void 0 ? void 0 : data.field_data) || {};

          // Start with existing data
          var updatedOriginalData = _objectSpread({}, existingOriginalData);

          // Update with new field_data values
          Object.keys(newFieldData).forEach(function (fieldName) {
            updatedOriginalData[fieldName] = newFieldData[fieldName];
          });

          // For fields that were in existingOriginalData but NOT in newFieldData,
          Object.keys(existingOriginalData).forEach(function (fieldName) {
            if (!(fieldName in newFieldData)) {
              updatedOriginalData[fieldName] = null;
            }
          });
          s.submissionOriginalFieldData[data.patient_id][data.id] = updatedOriginalData;
        } else {
          // Replace entirely (first open or normal fetch with no changes)
          s.submissionOriginalFieldData[data.patient_id][data.id] = _objectSpread({}, (data === null || data === void 0 ? void 0 : data.field_data) || {});
        }
      }
    }
  });
};